/**************************************************
 * Nombre:       Formulario_Producto_Informacion_Tab
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoDinero from "../../../Modulo_formularios/Componentes/IngresoDinero";
import {NotesOutlined} from '@mui/icons-material'

const Formulario_Producto_Informacion_Tab = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={NotesOutlined} nombre={'Titulo de Informacion'}
                                  dato={'nombre'} {...props}
                                  ejemplo={'Detalles'}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={10}  nombre={'Informacion adicional'}
                                   dato={'descripcion'} {...props}
                                   requerido={'Campo Requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Producto_Informacion_Tab